import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { RegistrationComponent } from './auth/registration/registration.component'
import { ContentComponent } from './shared/components/layout/content/content.component';
import { content } from './shared/routes/routes';
import { FullComponent } from './shared/components/layout/full/full.component';
import { full } from './shared/routes/full.routes';
import { AuthGuard } from './shared/guards/auth.guard';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { TermsAndConditionsComponent } from './shared/components/terms-and-conditions/terms-and-conditions.component';
import { termsAndConditionsGuard } from './shared/guards/terms-and-conditions.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard/default',
    pathMatch: 'full'
  },
  {
    path: 'auth/login',
    component: LoginComponent,
  },
  {
    path: 'auth/login/back-from-conditions',
    component: LoginComponent,
  },
  {
    path: 'auth/forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'auth/register',
    component: RegistrationComponent,
    pathMatch: 'full'
  },
  // {
  //   path: 'terms-and-conditions',
  //   component: TermsAndConditionsComponent
  // },
  // {
  //   path: 'terms-and-conditions/from-login',
  //   component: TermsAndConditionsComponent
  // },
  {
    path: '',
    component: ContentComponent,
    // canActivate: [AuthGuard],
    canActivate: [AuthGuard, termsAndConditionsGuard],
    children: content,
  },
  {
    path: '',
    component: FullComponent,
    // canActivate: [AuthGuard],
    children: full
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [
    [RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled', })
    ]
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
